import React, { useState } from "react"
import moment from "moment"
import { Dropdown, Menu, Modal } from "antd"
import Loader from "../Loader"
import { Link } from "react-router-dom"
import config from "../Config"

const LessonSlots = ({ data }) => {
  const [lessonData, setLessonData] = useState()
  const [open, setOpen] = useState(false)

  const [SlotsData, setSlotsdata] = useState([])
  const [SlotsModal, setSlotsModal] = useState(false)
  const [LessonModal, setLessonModal] = useState(false);

  console.log("data", data)

  function getSessionType(lesson_type) {
    switch (lesson_type) {
      case 'Manual': return (<div className="ribbon ribbon-top-left bg-light-green"><span>{lesson_type}</span></div>)
      case 'Automatic': return (<div className="ribbon ribbon-top-left bg-light-blue2"><span>{lesson_type}</span></div>)
    }
  }
  const getEndDate = (Course) => {

    const practicalHours = Number(Course?.cources?.practical) || 0;
    const theoryHours = Number(Course?.cources?.theory) || 0;
    const courseDurationHours = practicalHours + theoryHours;
    const daysRequired = Math.ceil(courseDurationHours / 2);

    let currentDate = moment(Course?.bookingdate, "YYYY-MM-DD");
    let validDaysCount = 0;
    const overallEndDate = currentDate.clone();

    // Calculate the overall end date for multi-day events (for Month view)
    while (validDaysCount < daysRequired) {
      if (overallEndDate.day() !== 0 && overallEndDate.day() !== 6) { // Skip weekends
        validDaysCount++;
      }
      if (validDaysCount < daysRequired) {
        overallEndDate.add(1, "days");
      }
    }

    return overallEndDate;
  }

  return (
    <>
      <div className='table-responsive'>
        <table className="jean-table table">
          <tbody>
            {data?.slice(0, 3)?.map((lesson, i) => {
              return (
                <tr key={i} className="" >
                  <td className=" box">
                    <div className="therapist-info ">
                      {getSessionType(lesson.cartype)}
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info ps-2">
                      <h4 className="mb-1 fs-5">Student Name</h4>
                      <p className="mb-0">
                        {lesson?.customername || "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info col-10">
                      <h4 className="mb-1 fs-5">Course Name</h4>
                      <p className="mb-0 text-truncate">
                        {lesson?.courseTitle || "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Slot Date </h4>
                      <p className="mb-0">
                        {moment(lesson?.date, "DD-MM-YYYY").format("DD MMM, YYYY") || "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Slot Time </h4>
                      <p className="mb-0">
                        {lesson?.time || "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Status</h4>
                      <div>{lesson?.status === 0 ?
                        <span className="text-success fw-bold">Completed</span>
                        : <span className="text-danger fw-bold">Not-Completed</span>}</div>
                    </div>
                  </td>

                  <td>
                    <Dropdown style={{ width: '270px' }} overlay={
                      <Menu className="p-1">
                        <Menu.Item key={1}>
                          {
                            <button className="dropdown-item"
                              onClick={() => { setLessonModal(true); setLessonData(lesson?.Lesson) }}
                            >
                              <i className="bi bi-eye me-2 text-black"></i>
                              Lesson
                            </button>
                          }
                        </Menu.Item>
                        <Menu.Item key={2}>
                          {
                            <button className="dropdown-item"
                              onClick={() => { setOpen(true); setSlotsdata(lesson) }}
                            >
                              <i className="icon-timer2 me-2 text-black"></i>
                              Slot Details
                            </button>
                          }
                        </Menu.Item>
                      </Menu>
                    } className="">
                      <a
                        onClick={(e) => e.preventDefault()}
                        className="ps-dropdown__toggle">
                        <i className="icon-ellipsis"></i>
                      </a>
                    </Dropdown>
                  </td>
                </tr>
              )
            })}

            {data?.length === 0 && (
              <tr>
                <td colSpan="5" className="alert alert-success ps-4">No Upcoming Lesson Slots Found !!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="ps-card__footer text-end d-flex justify-content-end pt-4">
        <Link onClick={() => setSlotsModal(true)} className="ps-card__morelink fs-4">
          View All Upcoming Slots
          <i className="icon icon-chevron-right"></i>
        </Link>
      </div>

      {/* View Details Modal */}
      <Modal
        open={open}
        title="Slot Details"
        centered
        onCancel={() => setOpen(false)}
        width={700}
        bodyStyle={{ padding: '0' }}
        footer={null}
      >
        <div className="bg-gradientt p-4">
          <div className='p-2 pb-0'>
            <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
              <tbody>
                <tr>
                  <th className='col-4 text-green p-3'>Student Name</th>
                  <td className='p-3'>{SlotsData?.customername || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Contact</th>
                  <td className='p-3'>{SlotsData?.Lesson?.user?.mobile || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Email</th>
                  <td className='p-3'>{SlotsData?.Lesson?.user?.email || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Course Name</th>
                  <td className='p-3'>{SlotsData?.courseTitle || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Slot Date</th>
                  <td className='p-3'>{moment(SlotsData?.date, "DD-MM-YYYY").format("DD MMM , YYYY") || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Slot Time</th>
                  <td className='p-3'>{SlotsData?.time || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Completed Slots</th>
                  <td className='p-3'>{SlotsData?.completedslots} / {SlotsData?.totalslots}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Completed Hours</th>
                  <td className='p-3'>{SlotsData?.completedslots * 2} Hours / {SlotsData?.TotalHour} Hours</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Slot Status</th>
                  <td className={`p-3 text-${SlotsData?.status === 1 ? "danger" : "green"}`}>{SlotsData?.status === 1 ? "Not-Completed" : "Completed"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>

      <Modal
        open={LessonModal}
        title="Lesson Details"
        centered
        onCancel={() => setLessonModal(false)}
        width={700}
        bodyStyle={{ padding: '0' }}
        footer={null}
      >
        <div className="bg-gradientt p-4">
          <div className='p-2 pb-0'>
            <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
              <tbody>
                {/* <tr>
                  <th className='col-4 text-green p-3'>Provisional Licence?</th>
                  <td className='p-3'>Yes</td>
                </tr> */}

                <tr>
                  <th className='col-4 text-green p-3'>Car Type</th>
                  <td className='p-3'>{lessonData?.cartype || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Name</th>
                  <td className='p-3'>{lessonData?.user?.name || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Student Contact</th>
                  <td className='p-3'>{lessonData?.user?.mobile || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Student Email</th>
                  <td className='p-3'>{lessonData?.user?.email || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Course Name</th>
                  <td className='p-3'>{lessonData?.cources?.title || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Slot Time</th>
                  <td className='p-3'>{lessonData?.bookingtime || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Start Date</th>
                  <td className='p-3'>{moment(lessonData?.bookingdate).format("DD MMM , YYYY") || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>End Date</th>
                  <td className='p-3'>{moment(getEndDate(lessonData)).format("DD MMM , YYYY") || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Amount (£)</th>
                  <td className='p-3'>£ {lessonData?.updated_price || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Status</th>
                  <td className='p-3 text-warning'>In-Progress</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>

      {/* All Slots Details */}
      <Modal
        open={SlotsModal}
        title="Lesson Slots Details"
        centered
        onCancel={() => setSlotsModal(false)}
        width={950}
        bodyStyle={{ padding: '0' }}
        footer={null}
      >
        <div className="bg-gradientt p-4">
          <div className='p-2 pb-0'>
            <div className='table-responsive'>
              <table className="jean-table table">
                <tbody>
                  {data?.map((lesson, i) => {
                    return (
                      <tr key={i} className="" >
                        <td className=" box">
                          <div className="therapist-info ">
                            {getSessionType(lesson.cartype)}
                          </div>
                        </td>

                        <td>
                          <div className="therapist-info ps-2">
                            <h4 className="mb-1 fs-5">Student Name</h4>
                            <p className="mb-0">
                              {lesson?.customername || "--"}
                            </p>
                          </div>
                        </td>


                        <td>
                          <div className="therapist-info col-10">
                            <h4 className="mb-1 fs-5">Course Name</h4>
                            <p className="mb-0 text-truncate">
                              {lesson?.courseTitle || "--"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="therapist-info">
                            <h4 className="mb-1 fs-5">Slot Date </h4>
                            <p className="mb-0">
                              {moment(lesson?.date, "DD-MM-YYYY").format("DD MMM, YYYY") || "--"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="therapist-info">
                            <h4 className="mb-1 fs-5">Slot Time </h4>
                            <p className="mb-0">
                              {lesson?.time || "--"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="therapist-info">
                            <h4 className="mb-1 fs-5">Status</h4>
                            <p className={`mb-0 text-capitalize text-${lesson.status === 1 ? 'danger' : 'green'} fw-semibold`}>
                              {lesson?.status === 1 ? "Not-Completed" : "Completed"}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )
                  })}

                  {data?.length === 0 && (
                    <tr>
                      <td colSpan="5" className="alert alert-success ps-4">No Lesson Slots Found !!</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default LessonSlots
